import { useCallback } from "react";
import { getInlineHelpStoreValue } from "../store/inlineHelpStore";
import { downloadTermManualAction$ } from "../store/downloadTermManualStore";
function useDownloadTermManualActions() {
    var pageId = getInlineHelpStoreValue().pageId;
    var downloadTermManual = useCallback(function(s3Object) {
        if (!pageId) return;
        downloadTermManualAction$.next({
            termKey: s3Object
        });
    }, [
        pageId
    ]);
    return {
        downloadTermManual: downloadTermManual
    };
}
export default useDownloadTermManualActions;

//# sourceMappingURL=useDownloadTermManualActions.js.map